// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
/**
 * Configurable thresholds that determine the auto-computed Go/No-Go verdict for a release. All fields are optional — only configured thresholds are evaluated.
 * @export
 * @interface ReleaseGoNoGoThreshold
 */
export interface ReleaseGoNoGoThreshold {
  /**
   * Minimum overall pass rate percentage required for a Go verdict
   * @type {number}
   * @memberof ReleaseGoNoGoThreshold
   */
  minPassRate?: number;
  /**
   * Maximum number of total open defects allowed across all severities
   * @type {number}
   * @memberof ReleaseGoNoGoThreshold
   */
  maxOpenDefects?: number;
  /**
   * Minimum percentage of failed executions that must have attachments
   * @type {number}
   * @memberof ReleaseGoNoGoThreshold
   */
  minEvidenceCoverage?: number;
}

export function ReleaseGoNoGoThresholdFromJSON(
  json: any
): ReleaseGoNoGoThreshold {
  return {
    minPassRate: !exists(json, "min_pass_rate")
      ? undefined
      : json["min_pass_rate"],
    maxOpenDefects: !exists(json, "max_open_defects")
      ? undefined
      : json["max_open_defects"],
    minEvidenceCoverage: !exists(json, "min_evidence_coverage")
      ? undefined
      : json["min_evidence_coverage"],
  };
}

export function ReleaseGoNoGoThresholdToJSON(
  value?: ReleaseGoNoGoThreshold
): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    min_pass_rate: value.minPassRate,
    max_open_defects: value.maxOpenDefects,
    min_evidence_coverage: value.minEvidenceCoverage,
  };
}
